// This file was automatically generated from appshared.dialog.inviteToPassport.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.inviteToPassport');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.patients');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.form = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PromptDialogContainer"><div class="email-duplicate-alert"></div><div class="patient-invite-status"></div><form><div class="passport-invite-form"><p class="el8LargeFontSize el8Bold mt10 mb5">Invite Patient to Passport</p><div class="el8Spacer"><p class="el8Bold">Email address where invitation will be sent:</p><div class="el8TextareaWrap mb20"><textarea type="text" class="w100" name="email"></textarea></div><p class="el8Bold">Cell phone number used for account authentication:</p><div class="el8Wrap mb10"><select name="passportPhone" class="which-phone-dropdown w100"></select></div></div><div class="edit-phone-nums-section el8Spacer el8SectionDivider hidden"><p class="el8Bold">Edit phone numbers on file for patient:</p><p class="el8ItalicText el8SystemText mb20">Note: Changes made here will be reflected in patient\'s demographics.</p><div class="el8FieldSection mb10"><label class="el8label el8FieldLong"><select name="phone1Type" class="w100">');
  var ptList8125 = opt_data.phoneTypes;
  var ptListLen8125 = ptList8125.length;
  for (var ptIndex8125 = 0; ptIndex8125 < ptListLen8125; ptIndex8125++) {
    var ptData8125 = ptList8125[ptIndex8125];
    output.append('<option value="', soy.$$escapeHtml(ptData8125[0]), '">', soy.$$escapeHtml(ptData8125[1]), '</option>');
  }
  output.append('</select></label><div class="el8FieldLongLabelPadding el8TextareaWrap"><input name="phone1" class="w100"/></div></div><div class="el8FieldSection mb10"><label class="el8label el8FieldLong"><select name="phone2Type" class="w100">');
  var ptList8133 = opt_data.phoneTypes;
  var ptListLen8133 = ptList8133.length;
  for (var ptIndex8133 = 0; ptIndex8133 < ptListLen8133; ptIndex8133++) {
    var ptData8133 = ptList8133[ptIndex8133];
    output.append('<option value="', soy.$$escapeHtml(ptData8133[0]), '">', soy.$$escapeHtml(ptData8133[1]), '</option>');
  }
  output.append('</select></label><div class="el8FieldLongLabelPadding el8TextareaWrap"><input name="phone2" class="w100"/></div></div></div></div><div class="el8Spacer el8SectionDivider lhs-prefs"><p class="el8LargeFontSize el8Bold mt10 mb5">Passport Sharing Options</p><p class="el8Bold el8Spacer5">Sections In Clinical Profile To Be Shared Through Passport:</p>');
  el8.template.appshared.dialog.inviteToPassport.lhsRadioButtons(null, output);
  output.append('<p class="el8Bold mt15 mb5">These Chart Items Will Also Be Shared through Passport:</p>');
  el8.template.appshared.dialog.inviteToPassport.lhsAlsoShared(null, output);
  output.append('</div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.lhsRadioButtons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Wrap ebs-col-xs-10 padr0"><div class="padl20 ebs-radio"><label class="el8label el8Radio2"><input type="radio" name="lhsPrefs" value="2"/>Objective Data Only</label><ul class="ebs-text-muted el8Wrap ebs-list-unstyled padl20 padb10"><li class="el8BulletText">Allergies, Drug Intolerance, Medications, and Vaccines only</li><li class="el8BulletText"><span class="el8ItalicText el8GrayText">This does <span class="el8Bold">not</span> satisfy MIPS requirements</span></li></ul></div><div class="padl20 ebs-radio"><label class="el8label el8Radio2"><input type="radio" name="lhsPrefs" value="1"/>Satisfies MIPS Requirements</label><ul class="ebs-text-muted el8Wrap ebs-list-unstyled padl20 padb10"><li class="el8BulletText">Objective data above, plus</li><li class="el8BulletText">Problem List</li></ul></div><div class="padl20 ebs-radio"><label class="el8label el8Radio2"><input type="radio" name="lhsPrefs" value="0" checked />Entire Clinical Profile except the Confidential section</label><ul class="ebs-text-muted el8Wrap ebs-list-unstyled padl20 padb10"><li class="el8BulletText">MIPS requirements above, plus</li><li class="el8BulletText">History, Legal Reports and Patient\'s Provider List</li></ul></div><div class="padl20 ebs-radio"><label class="el8label el8Radio2"><input type="radio" name="lhsPrefs" value="3" checked />Entire Clinical Profile, Expanded Summary, excluding Confidential</label><ul class="ebs-text-muted el8Wrap ebs-list-unstyled padl20 padb10"><li class="el8BulletText">Entire clinical profile, expanded summary, implantable devices, excluding confidential</li></ul></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.lhsAlsoShared = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul class="el8Wrap padl20 ebs-list-unstyled"><li class="el8BulletText padb5">Visit summaries, including the tests ordered, treatment, plan and follow-up documented in each visit note</li><li class="el8BulletText padb5">Date of upcoming appointment</li><li class="el8BulletText padb5">Date of last appointment</li></ul><p class="el8Bold mt15 mb5">CCDA Downloads:</p><p class="padb5">Patients can download the above information in CCDA format from Passport.</p><p class="el8Bold mt15 mb5">Manual Sharing:</p><p class="padb5">Besides sharing the above, Passport allows you to write letters to the patient and attach any chart document you wish, including reports, orders and referrals.</p><div class="disablePatientPassportContainer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.disablePatientPassport = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><p class="el8Bold mt15 mb5">Disable Patient Passport:</p><p class="padb5">If the practice would like to turn off Patient Passport access for a patient, click the Disable Patient Passport button below.</p><div class="el8DialogButtonContainer"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" class="el8button el8RedButton patient-passport-account-disable ebs-btn ebs-btn-default">Disable Patient Passport</button></li></ul></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.patientPhones = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.phone1) ? '<option value="phone1" data-type="' + soy.$$escapeHtml(opt_data.phone1Type) + '">' + soy.$$escapeHtml(opt_data.phone1) + ' (' + soy.$$escapeHtml(opt_data.phone1Type) + ')</option>' : '', (opt_data.phone2) ? '<option value="phone2" data-type="' + soy.$$escapeHtml(opt_data.phone2Type) + '">' + soy.$$escapeHtml(opt_data.phone2) + ' (' + soy.$$escapeHtml(opt_data.phone2Type) + ')</option>' : '', (opt_data.newPhoneEntry) ? '<option value="new">New or edited number...</option>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.inviteStatusDiv = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.ptRegistrationInfo.inviteStatus) {
    case 'NOT_INVITED':
      output.append('<div class="patient-invite-status el8NotificationAlert"><p class="el8AlignCenter el8Bold">');
      el8.template.ptdata.patients.fullName(opt_data.patient, output);
      output.append(' does not have access to Passport.', (opt_data.ptRegistrationInfo.expireTime) ? ' <a class="details-trigger">Details</a>' : '', '</p>');
      el8.template.appshared.dialog.inviteToPassport.inviteDetails(opt_data, output);
      output.append('</div>');
      break;
    case 'INVITED':
      output.append('<div class="patient-invite-status el8NotificationCaution"><p class="el8AlignCenter el8Bold">Invitation to Passport has been sent. <a class="details-trigger">Details</a></p>');
      el8.template.appshared.dialog.inviteToPassport.inviteDetails(opt_data, output);
      output.append('</div>');
      break;
    case 'USED':
      output.append('<div class="patient-invite-status el8NotificationGo"><p class="el8AlignCenter el8Bold">');
      el8.template.ptdata.patients.fullName(opt_data.patient, output);
      output.append(' has access to Passport. <a class="details-trigger">Details</a></p>');
      el8.template.appshared.dialog.inviteToPassport.inviteDetails(opt_data, output);
      output.append('</div>');
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.inviteDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.ptRegistrationInfo.inviteTime) {
    output.append('<ul class="patient-invite-details el8Spacer ml10 ebs-list-unstyled">');
    if (opt_data.ptRegistrationInfo.expireTime) {
      output.append('<li class="el8BulletText el8AppText">Invitation sent ');
      el8.template.appshared.dialog.inviteToPassport.patientEmail_(opt_data, output);
      output.append('on ', (soy.$$escapeHtml(opt_data.ptRegistrationInfo.inviteTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.ptRegistrationInfo.inviteTime)) : ''), ' expired on ', (soy.$$escapeHtml(opt_data.ptRegistrationInfo.expireTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.ptRegistrationInfo.expireTime)) : ''), '.</li>');
    } else {
      if (opt_data.ptRegistrationInfo.registrationTime) {
        output.append('<li class="el8BulletText el8AppText">');
        el8.template.ptdata.patients.fullName(opt_data.patient, output);
        output.append(' created Passport account on ', (soy.$$escapeHtml(opt_data.ptRegistrationInfo.registrationTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.ptRegistrationInfo.registrationTime)) : ''), '.</li>');
      }
      output.append('<li class="el8BulletText el8AppText">Invitation e-mail sent ');
      el8.template.appshared.dialog.inviteToPassport.patientEmail_(opt_data, output);
      output.append('on ', (soy.$$escapeHtml(opt_data.ptRegistrationInfo.inviteTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.ptRegistrationInfo.inviteTime)) : ''), '.</li>', (opt_data.ptRegistrationInfo.smsTime && opt_data.ptRegistrationInfo.invitePhone) ? '<li class="el8BulletText el8AppText">Invitation Code sent to ' + soy.$$escapeHtml(opt_data.ptRegistrationInfo.invitePhone) + ' on ' + (soy.$$escapeHtml(opt_data.ptRegistrationInfo.smsTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.ptRegistrationInfo.smsTime)) : '') + '.</li>' : '');
      if (opt_data.ptRegistrationInfo.passportUsernames.patients.length) {
        output.append('<li class="el8BulletText el8AppText">Current Patient Passport Username', (opt_data.ptRegistrationInfo.passportUsernames.patients.length > 1) ? 's' : '', ': ');
        var patientList8240 = opt_data.ptRegistrationInfo.passportUsernames.patients;
        var patientListLen8240 = patientList8240.length;
        for (var patientIndex8240 = 0; patientIndex8240 < patientListLen8240; patientIndex8240++) {
          var patientData8240 = patientList8240[patientIndex8240];
          output.append('<a href="mailto:', soy.$$escapeHtml(patientData8240), '">', soy.$$escapeHtml(patientData8240), '</a>', (! (patientIndex8240 == patientListLen8240 - 1)) ? ', ' : '');
        }
        output.append('</li>');
      }
      if (opt_data.ptRegistrationInfo.passportUsernames.designates.length) {
        output.append('<li class="el8BulletText el8AppText">Current Legal Representative Passport Username', (opt_data.ptRegistrationInfo.passportUsernames.designates.length > 1) ? 's' : '', ': ');
        var designateList8258 = opt_data.ptRegistrationInfo.passportUsernames.designates;
        var designateListLen8258 = designateList8258.length;
        for (var designateIndex8258 = 0; designateIndex8258 < designateListLen8258; designateIndex8258++) {
          var designateData8258 = designateList8258[designateIndex8258];
          output.append('<a href="mailto:', soy.$$escapeHtml(designateData8258), '">', soy.$$escapeHtml(designateData8258), '</a>', (! (designateIndex8258 == designateListLen8258 - 1)) ? ', ' : '');
        }
        output.append('</li>');
      }
      output.append((! opt_data.ptRegistrationInfo.registrationTime) ? '<li><p class="el8StandardFontSize el8DialogContainer el8Bold">Invitation Code: ' + soy.$$escapeHtml(opt_data.ptRegistrationInfo.inviteCode) + '</p></li>' : '');
    }
    output.append('</ul>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.patientEmail_ = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.ptRegistrationInfo.inviteEmail) ? 'to <a href="mailto:' + soy.$$escapeHtml(opt_data.ptRegistrationInfo.inviteEmail) + '">' + soy.$$escapeHtml(opt_data.ptRegistrationInfo.inviteEmail) + '</a> ' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.inviteToPassport.emailDuplicateAlert = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8NotificationStop el8AlignCenter el8Bold">The email address you entered is already in use. Please choose another email address to send the Passport invitation to.</p>');
  if (!opt_sb) return output.toString();
};
